
// Configure API base URL
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

// Log para depuração - mostra a URL da API que está sendo usada
console.log('API URL configurada:', API_BASE_URL);
